import React from 'react';
import {
  TextField,
  Box,
  Typography,
  MenuItem,
  Button,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import modelTasks from '../../constants/modelTasks.json';
import modelFrameworks from '../../constants/modelFrameworks.json';

const NewModelFormFields = ({
  form,
  handleChange,
  showFileInput = true,
  showTestImages = true,
  testImagesRequired = true,
  existingTestImages = [],
  title = 'New Model Info',
  width = '50%',
}) => {
  return (
    <>
      <Typography variant="h3" fontWeight={700} color="black" mt={4}>
        {title}
      </Typography>
      <Typography variant="h6" color="rgb(158, 151, 151)" mt={2}>
        Fill in your model details to import it to the Model Zoo.
      </Typography>

      <Box
        sx={{
        width: width,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        padding: 2,
        mt: 1,
        }}
      >
        <Typography variant="h7" color="black">
          Model info
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
        <TextField
        required
          label="Model name"
          name="modelName"
          value={form.modelName || ''}
          onChange={handleChange}
          fullWidth
          autoComplete="off"
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
        />
        
        <TextField
        required
          label="Model weight filename(s)"
          name="modelFileName"
          value={form.modelFileName || ''}
          onChange={handleChange}
          fullWidth
          autoComplete="off"
          helperText="Separate multiple filenames with commas."
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
        />
  

        {/* {showFileInput && (
          <TextField
            required
            type="file"
            name="modelFile"
            onChange={handleChange}
            fullWidth
            autoComplete="off"
            inputProps={{ accept: '.pt,.onnx, .pth, .ckpt' }}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
          />
        )} */}
        </Box>
        {/* <Typography variant="h7" color="black" mt={2}>
          Description
        </Typography> */}
        <TextField
          required
          label="Describe your model"
          name="description"
          value={form.description || ''}
          onChange={handleChange}
          multiline
          rows={2}
          fullWidth
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
        />

        <TextField
          required
          select
          label="Model category"
          name="category"
          value={form.category || ''}
          onChange={handleChange}
          fullWidth
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
        >
          <MenuItem value="Quality monitoring">Quality monitoring</MenuItem>
          <MenuItem value="Assets monitoring">Assets monitoring</MenuItem>
        </TextField>

        

      <Box
        sx={{
        width: width,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        mt: 1,
        }}
      >
      <Typography variant="h7" color="black">
          Github URL
        </Typography>
        <TextField
          required
          label="Github URL"
          name="githubURL"
          value={form.githubURL || ''}
          onChange={handleChange}
          fullWidth
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
        />
        </Box>


        {showTestImages && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h7" color="black">
            {form.textPromptInput ? 'Test prompt' : `Test images (1-3 ${testImagesRequired ? 'required' : 'optional'})`}
          </Typography>
          <FormControlLabel
            control={(
              <Checkbox
                name="textPromptInput"
                checked={Boolean(form.textPromptInput)}
                onChange={handleChange}
                size="small"
              />
            )}
            label="Text prompt input"
          />
        </Box>}
        {showTestImages && <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {form.textPromptInput ? (
            <TextField
              name="modelTestImages"
              label="Test prompt"
              value={form.modelTestImages || ''}
              onChange={handleChange}
              multiline
              minRows={3}
              required={testImagesRequired}
              fullWidth
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
            />
          ) : <Button
            variant="outlined"
            component="label"
            sx={{
            borderRadius: '12px',
            textTransform: 'none',
            justifyContent: 'center',
            color: 'rgba(0, 0, 0, 0.67)',
            borderColor: 'rgba(0, 0, 0, 0.23)', // same as TextField default border
            backgroundColor: 'white',
            '&:hover': {
              borderColor: 'black',
              backgroundColor: 'rgba(0,0,0,0.04)',
            },
            padding: '14px 14px',
            fontWeight: 400,
            fontSize: '16px',
          }}
          >
            {testImagesRequired ? 'Upload Images*' : 'Replace Test Images'}
            <input
              type="file"
              name="modelTestImages"
              accept=".png,.jpg,.jpeg"
              multiple
              hidden
              required={testImagesRequired}
              onChange={(e) => {
                const newFiles = Array.from(e.target.files);
                const existingFiles = Array.isArray(form.modelTestImages)
                  ? form.modelTestImages
                  : [];
                const merged = [...existingFiles, ...newFiles].slice(0, 3); // enforce max 3

                handleChange({
                  target: {
                    name: "modelTestImages",
                    type: "file-multi",
                    value: merged,
                  }
                });

                // reset input value so selecting the same file twice still triggers onChange
                e.target.value = null;
              }}
            />
          </Button>}

          {/* Preview selected filenames */}
          {!form.textPromptInput && form.modelTestImages?.length > 0 && (
            <Box sx={{ mt: 1, fontSize: "0.9rem", color: "gray" }}>
              {form.modelTestImages.map((file, idx) => (
                <div key={idx}>{file.name}</div>
              ))}
            </Box>
          )}
          {!form.textPromptInput && !form.modelTestImages?.length && existingTestImages.length > 0 && (
            <Box sx={{ mt: 1, fontSize: "0.9rem", color: "gray" }}>
              Current images: {existingTestImages.map((image, index) => (
                <div key={image}>{`Image ${index + 1}`}</div>
              ))}
            </Box>
          )}
        </Box>}


      </Box>
    </>
  );
};

export default NewModelFormFields;
